import React from "react";
import {MessageWithMetadata, ProffCompanyCard, SourceInfo} from "../../../../types";

// rawSources keeps the backend indices; sources holds the renumbered, cited subset.
// hideCharts: the thoughts/progress panel never renders charts, streaming or not.
// proffCompanies is thread-level, not per message: it is keyed by orgNr.
export type GPTMeta = MessageWithMetadata & {
    isStreaming?: boolean;
    rawSources?: SourceInfo[];
    hideCharts?: boolean;
    proffCompanies?: Record<string, ProffCompanyCard>;
};

export const GPTMetaContext = React.createContext<GPTMeta | undefined>(
    undefined
);
